import { render } from "./TrainModel.vue?vue&type=template&id=634b635a"
import script from "./TrainModel.vue?vue&type=script&lang=js"
export * from "./TrainModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__